export default __webpack_public_path__ + "static/media/logo.549cefa0.jpg";